import { ErrorBoundary } from '@/lib/error';
import { ErrorBanner } from '@/components/banner';
import { isRecordsLikeCell } from '@/core/cell';

import { Visualisation } from '../../types';
import { VisualisationPanel } from '../visualisation';
import { useExplorationCellContext } from '../../exploration/exploration-cell-context';

import style from './visualisations.module.scss';

interface VisualisationsProps {
  visualisations: Visualisation[];
  onEditVisualisation?(index: number): void;
  isInView: boolean;
  isResized: boolean;
}

export const Visualisations = (props: VisualisationsProps) => {
  const { visualisations, onEditVisualisation } = props;

  const { cell, setVisualisation, removeVisualisation, isPipelinePreviewVisible } =
    useExplorationCellContext();

  if (!isRecordsLikeCell(cell) || visualisations.length === 0) {
    return null;
  }

  return (
    <div className={style.visualisations}>
      {visualisations.map((visualisation, idx) => (
        <ErrorBoundary
          key={idx}
          fallback={(error) => <ErrorBanner description={(error as any).message} />}>
          <VisualisationPanel
            idx={idx}
            pipeline={cell.pipeline}
            visualisation={visualisation}
            onClose={() => removeVisualisation(idx)}
            onEdit={() => onEditVisualisation?.(idx)}
            onVisualisationChange={(visualisation) => setVisualisation(idx, visualisation)}
            isInView={props.isInView}
            isResized={props.isResized}
            hideHeader={!isPipelinePreviewVisible}
          />
        </ErrorBoundary>
      ))}
    </div>
  );
};
